import actions from './actions'
import getters from './getters'
import mutations from './mutations'

const state = {
  users: [],
  roles: [],
  pagination: {},
  loginDebug: []
}

export default {
  namespaced: false,
  state,
  actions,
  getters,
  mutations
}
